import styled from 'styled-components';

export const Container = styled.div`
  height: auto;
  width: 100%;
  background-color: #eee;
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  border-top: 1px solid rgba(34, 36, 38, 0.15);
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 1rem;

  @media screen and (max-width: 800px) {
    flex-direction: column;

    button {
      margin: 0.2rem 0;
    }
  }
`;
